'use client'

import { cn } from '../cn'
import { ActionCard } from './action-card'
import { Button } from './button'

/**
 * PreviewCard — read-only preview of an artifact (email draft, doc
 * outline, calendar event). Output card; pairs with a populated
 * `result` for the model. Optional `actions` row at the bottom for
 * follow-ups (Open in editor, Discard, etc.).
 *
 * Per `apps/agent/plans/plan-action-cards.md` Phase 4.
 */

export interface PreviewCardProps {
  title: string
  description?: string
  attribution?: string
  /** Markdown body to render. Receives the same prose styling as assistant text. */
  bodyMarkdown?: string
  actions?: Array<{ id: string; label: string; href?: string; onClick?: () => void }>
  /** Optional class on the body container for layout overrides. */
  bodyClassName?: string
}

export function PreviewCard({
  title,
  description,
  attribution,
  bodyMarkdown,
  actions,
  bodyClassName,
}: PreviewCardProps) {
  return (
    <ActionCard
      title={title}
      description={description}
      attribution={attribution}
      tone="neutral"
      footer={
        actions && actions.length > 0 ? (
          <>
            {actions.map((a) => (
              <Button key={a.id} type="button" size="sm" variant="outline" asChild={!!a.href} onClick={a.onClick}>
                {a.href ? <a href={a.href}>{a.label}</a> : <span>{a.label}</span>}
              </Button>
            ))}
          </>
        ) : null
      }>
      {bodyMarkdown ? (
        <div className={cn('whitespace-pre-wrap text-sm text-foreground', bodyClassName)}>{bodyMarkdown}</div>
      ) : null}
    </ActionCard>
  )
}
